import { render, staticRenderFns } from "./NotConnected.vue?vue&type=template&id=0bb84197&scoped=true"
import script from "./NotConnected.vue?vue&type=script&lang=js"
export * from "./NotConnected.vue?vue&type=script&lang=js"
import style0 from "./NotConnected.vue?vue&type=style&index=0&id=0bb84197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb84197",
  null
  
)

export default component.exports